/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of PrintablesList
 * Alfapeople -Customisation object -For Print page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface IPrint {
  printHeading?: string;
  imageUrl?: string;
  textDescription?: string;
  downloadLink?: string;
}
/**
 *
 * Print component
 * @extends Component
 */
export class Print extends Component {
  private readonly printPage: IPrint = {
    printHeading: 'Color A Thank-You Sign ',
    imageUrl:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1X',
    textDescription:
      'Show the people in your community how much you appreciate them! Color a big THANK YOU sign with bright and happy colors. Have a grown-up tape it or hang it up in a window or on your house where everyone can see it.Parents, share the happiness with #Let’sPlaySaudi',
    downloadLink:
      'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1ZY6',
  };
  public render(): JSX.Element | null {
    return (
      <div className='row'>
        <div className='col-lg-12 col-md-12'>
          <h1 className='print-heading'>{this.printPage.printHeading}</h1>
        </div>
        <div className='col-lg-12 col-md-12'>
          <div className='printContainer'>
            <img
              className='img-responsive'
              src={this.printPage.imageUrl}
              alt={this.printPage.printHeading}
            />
            <p className='print-description'>
              {ReactHtmlParser(this.printPage.textDescription)}
            </p>
            <a href={this.printPage.downloadLink} className='print-download-link' target='_blank'>download
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Print;
